import { useEffect, useState } from "react";
import { api, fmtGYD, mediaUrl } from "@/lib/api";
import { ShoppingBag, MapPin, Search, Package } from "lucide-react";

export default function Storefront() {
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/storefront/products").then((r) => setProducts(r.data)).finally(() => setLoading(false)); }, []);
  const filtered = products.filter((p) => !search || p.name.toLowerCase().includes(search.toLowerCase()));
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <header className="bg-gradient-to-r from-indigo-700 to-indigo-900 text-white">
        <div className="max-w-6xl mx-auto px-4 py-5 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-white/15 flex items-center justify-center"><ShoppingBag /></div>
            <div><div className="font-bold text-xl font-head">GuyanaDiscounts.com</div><div className="text-xs text-indigo-200">Powered by MatrixShopping</div></div>
          </div>
          <div className="relative w-72 hidden sm:block">
            <Search className="absolute left-3 top-2.5 text-indigo-300" size={18} />
            <input data-testid="storefront-search" value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search products" className="w-full bg-white/10 placeholder-indigo-200 border border-white/20 rounded-lg pl-10 pr-3 py-2 text-sm outline-none text-white" />
          </div>
        </div>
      </header>
      <div className="max-w-6xl mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold font-head mb-1">Featured Products</h1>
        <p className="text-slate-500 mb-6">Approved and published by MatrixShopping merchants across Guyana</p>
        {loading ? <div className="text-slate-400">Loading…</div> : filtered.length === 0 ? (
          <div className="text-center py-20 text-slate-400"><Package className="mx-auto mb-3" size={40} /><p>No published products yet.</p><p className="text-sm">Merchants can publish via "Add to MatrixShopping".</p></div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
            {filtered.map((p) => (
              <div key={p.listing_id} data-testid={`store-product-${p.product_id}`} className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow border border-slate-100">
                <div className="aspect-square bg-slate-100 flex items-center justify-center overflow-hidden">
                  {p.images?.[0] ? <img src={mediaUrl(p.images[0].web)} alt={p.name} className="w-full h-full object-cover" /> : <Package className="text-slate-300" size={48} />}
                </div>
                <div className="p-4">
                  <div className="font-semibold leading-tight line-clamp-2 min-h-[2.5rem]">{p.name}</div>
                  <div className="flex items-center gap-1 text-xs text-slate-500 mt-1"><MapPin size={12} /> {p.merchant_name}</div>
                  <div className="mt-2 flex items-end justify-between">
                    <div>
                      {p.promo_price && <div className="text-xs text-slate-400 line-through mono">{fmtGYD(p.list_price)}</div>}
                      <div className="font-bold text-indigo-700 mono">{fmtGYD(p.price)}</div>
                    </div>
                    <div className={`text-xs px-2 py-0.5 rounded ${p.available_stock > 0 ? "bg-emerald-100 text-emerald-700" : "bg-rose-100 text-rose-700"}`}>{p.available_stock > 0 ? `${p.available_stock} in stock` : "Out of stock"}</div>
                  </div>
                  {p.delivery_available && <div className="text-xs text-indigo-600 mt-2">🚚 Delivery available</div>}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
